import { TileLayer, BitmapLayer, ScatterplotLayer } from 'deck.gl';
import GL from '@luma.gl/constants';


export function renderLayers({data}) {
 

  const point = new ScatterplotLayer({
    id: 'scatterplot-layer',
    data:data,
    pickable: false,
    opacity: 0.8,
    stroked: false,
    filled: true,
    radiusScale: 20,
    radiusMinPixels: 1,
    radiusMaxPixels: 40,
    lineWidthMinPixels: 0,
    getPosition: d => [d.X, d.Y],
    getRadius: 10,
    getFillColor: d => {
      if (d.RTC_2020 > 50) return [221, 28, 119];
      if (d.RTC_2020 <= 50) return [44, 162, 95];
      return [120,120,120]
    },
    getLineColor: d => [0, 0, 0],
  });

  //OSMタイルを読み込みベースマップとして表示
  const tileLayer = new TileLayer({
    id:"tile-layer",
    data: "https://c.tile.openstreetmap.org/{z}/{x}/{y}.png",
    minZoom: 0,
    maxZoom: 19,
    tileSize: 256,

    renderSubLayers: (props) => {
      const {
        bbox: { west, south, east, north }
      } = props.tile;

      return new BitmapLayer(props, {
        data: null,
        image: props.data,
        bounds: [west, south, east, north]
      });
    }
  });  

  //レイヤーの重なり順を配列で指定(先頭のレイヤーが一番下になる)
  return [point];
}
